const idProductoSuscripciones = {
    SuscriptorDigital: 79,
    SuscriptorADClubSinActivacion: 78,
    SuscriptorADClub: 86
}

export default idProductoSuscripciones;